<!-- #86 -->
<template>
  <v-col class="mx-4 py-0 mt-2">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0 mr-5"
        style="color: #23468c; font-weight: 500; width: 100%"
      >
        Vendor List
      </div>
      <v-spacer></v-spacer>
      <v-btn small color="primary" @click="editDetails(0)">Add Vendor </v-btn>
    </div>
    <v-divider class="mt-1 mb-4"></v-divider>

    <v-data-table
      :headers="headers"
      :items="list"
      :options.sync="options"
      :server-items-length="total"
      :loading="loader"
      class="elevation-1 mt-7"
      :items-per-page="25"
      :footer-props="{
        itemsPerPageOptions: [25, 50, 100, 250],
        showFirstLastPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-minus',
        nextIcon: 'mdi-plus',
      }"
    >
      <template v-slot:[`item.action`]="{ item }">
        <v-tooltip
          bottom
          v-if="
            checkPermission('app_osl_overtime_cost:edit_vendor') &&
            userCategory.user_category === 3
          "
        >
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              small
              class="mr-2"
              v-bind="attrs"
              v-on="on"
              @click="editDetails(item.id)"
            >
              mdi-pencil
            </v-icon>
          </template>
          <span>Edit</span>
        </v-tooltip>
      </template>
      <template v-slot:[`item.status`]="{ item }">
        <span :class="item.status == 1 ? 'badge-active' : 'badge'"
          >{{ item.status == true ? "Active" : "In-active" }}
        </span>
      </template>
      <template v-slot:[`item.vendor_start_date`]="{ item }"
        >{{ item.vendor_start_date | moment("DD MMM, YYYY") }}
      </template>

      <template v-slot:[`item.vendor_type_id`]> Warehouse </template>
      <template v-slot:top>
        <template>
          <v-form>
            <v-row class="custom-row pl-5 pr-5">
              <v-col cols="12" sm="3" v-if="userCategory.user_category == 3">
                <v-autocomplete
                  label="Vendor Name"
                  :items="vendors"
                  v-model="vendor_name"
                  item-text="vendor_name"
                  item-value="vendor_name"
                  outlined
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3">
                <v-menu
                  v-model="dateFilter"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="getFormattedDate(vendor_start_date)"
                      label="Start Date"
                      append-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      outlined
                      clearable
                      @click:clear="clearInput('vendor_start_date')"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="vendor_start_date"
                    @input="dateFilter = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="3">
                <v-menu
                  v-model="dateFilterarrival"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="getFormattedDate(vendor_end_date)"
                      label="End Date"
                      append-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      outlined
                      clearable
                      @click:clear="clearInput('vendor_end_date')"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="vendor_end_date"
                    @input="dateFilterarrival = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="3">
                <v-autocomplete
                  label="Status"
                  :items="vendorStatus"
                  v-model="status"
                  item-text="text"
                  item-value="value"
                  outlined
                ></v-autocomplete>
              </v-col>
              <v-col class="text-right">
                <v-btn class="success" color="primary" @click="searchAll"
                  >Search</v-btn
                >
                <v-btn color="white" class="ml-4" @click="allClear"
                  >Clear</v-btn
                >
              </v-col>
            </v-row>
          </v-form>
          <v-divider class="my-5"></v-divider>
        </template>
      </template>
    </v-data-table>
  </v-col>
</template>
<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data: () => ({
    detailsData: [],
    dateFilterarrival: null,
    dateFilter: null,
    saveLoader: false,
    vendorStatus: [
      { text: "Active", value: 1 },
      { text: "Inactive", value: 0 },
    ],
    headers: [
      {
        text: "Vendor Name",
        value: "vendor_name",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Type",
        value: "vendor_type_id",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Start Date",
        value: "vendor_start_date",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Status",
        value: "status",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Created by",
        value: "created_by",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Updated by",
        value: "updated_by",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Action",
        value: "action",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
    ],

    list: [],
    options: {},
    optionsDetails: {
      page: 1,
      itemsPerPage: 100,
      sortDesc: [false],
    },
    total: 0,
    vendors: [],
  }),

  watch: {
    dialog(val) {
      val || this.close();
    },
    options: {
      handler() {
        this.fetchList();
      },
      deep: true,
    },
    optionsDetails: {
      handler() {
        if (this.optionsDetails.page !== 1 || this.previusPage) {
          this.previusPage = true;
          if (this.item !== undefined) this.openDetails(this.item);
        }
      },
      deep: true,
    },
  },
  created() {
    this.getVendorList();
  },
  computed: {
    ...mapGetters(["userRole", "userCategory"]),
    getEndDate() {
      var endDate = new Date();
      endDate.setDate(endDate.getDate() + 1);
      endDate.setHours(0, 0, 0, 0); // Set hours, minutes, seconds, and milliseconds to zero
      return endDate.toISOString().split("T")[0]; // Keep only the date part
    },
  },
  methods: {
    ...mapActions(["snackBar", "getotVendorsLists", "getvendorDropdown"]),
    editDetails(id) {
      this.$router.push({
        name: "Addvendor",
        params: {
          id,
        },
      });
    },
    getVendorList() {
      this.getvendorDropdown().then((res) => {
        this.vendors = res.data;
      });
    },
    clearInput(val) {
      if (val == "vendor_start_date") {
        this.vendor_start_date = "";
      } else if (val == "vendor_end_date") {
        this.vendor_end_date = "";
      } else if (val !== null) {
        val = "";
      }
    },

    allFilters() {
      this.loader = true;
      let obj = {
        vendor_name: this.vendor_name,
        vendor_start_date: this.vendor_start_date,
        vendor_end_date: this.vendor_end_date,
        status: this.status,
      };
      Object.keys(obj).forEach((key) => {
        if (obj[key] === null || obj[key] === undefined || obj[key] === "") {
          delete obj[key];
        }
      });
      this.filtersArr = obj;
    },
    searchAll() {
      this.options.page = 1;
      this.loader = true;
      this.allFilters();
      this.getotVendorsLists({ ...this.options, ...this.filtersArr })
        .then((res) => {
          this.loader = false;
          this.list = res.data.records;
          this.total = res.data.total;
        })
        .catch(() => {
          this.loader = false;
        });
    },
    allClear() {
      this.vendor_start_date = null;
      this.vendor_end_date = null;
      this.status = "";
      this.vendor_name = "";
      this.filtersArr = [];
      this.fetchList();
    },

    fetchList() {
      this.list = [];
      this.loader = true;
      this.getotVendorsLists({ ...this.options, ...this.filtersArr })
        .then((res) => {
          this.loader = false;
          this.list = res.data.records;

          this.total = res.data.total;
        })
        .catch(() => {
          this.loader = false;
        });
    },
    reset() {
      this.file = "";
      this.boe_no = "";
      this.addDialog = false;
      this.dialog = "";
      this.$refs.form?.reset();
      this.$refs.form1?.reset();
      this.formData = {};
      this.editedIndex = -1;
      this.orderdetailsRow = false;
    },

    close() {
      this.dialog = false;
      this.exitdialog = false;
      this.allClear();
    },
  },
};
</script>
<style scoped>
.custom-footer {
  font-size: 17px;
  font-weight: bold;
  width: 100%;
  border-collapse: collapse;
  background-color: #add8e64f;
  margin-top: 70px; /* Adjust as needed */
  border: 1px solid gray; /* Add border styles as needed */
}
.custom-footer td {
  padding: 16px;
  background-color: #add8e64f;
  /* width: 500px; */
  border-top: 1px solid lightgray;
  text-align: left; /* Center the content */
}

.badge {
  display: inline-block;
  padding: 4px 10px;
  background-color: rgb(242, 126, 126);
  color: #fff;
  border-radius: 20px;
  width: 75px;
  font-size: 14px;
  text-align: center;
}
.badge-active {
  display: inline-block;
  padding: 4px 10px;
  background-color: green;
  color: #fff;
  border-radius: 20px;
  width: 75px;
  font-size: 14px;
  text-align: center;
}
</style>
